export enum TripPlannerTripItemTypes {
  ACCOMMODATION = 'ACCOMMODATION',
  EXPERIENCE = 'EXPERIENCE',
  NOTE = 'NOTE',
  ATTRACTION = 'ATTRACTION',
}
